/**
 * WARNING - consider removal or renames of these events breaking changes - as
 * they are now surfaced in the prebuilt
 */
export var EDITOR_PLUGIN_AI_PROVIDER_EVENTS = {
  /**
   * @private
   * @deprecated
   * This could change within the next few weeks, as we are looking to rework
   * the logic to better capture feedback collection when those requirements
   * become clearer. The change is likely to be an (additive) breaking API
   * change, in the form of a more specific, feedback-focused type on the
   * provider with information about success/failure.
   *
   * When a thumbs up button is clicked
   */
  THUMBS_UP: 'THUMBS_UP',
  /**
   * @private
   * @deprecated
   * This could change within the next few weeks, as we are looking to rework
   * the logic to better capture feedback collection when those requirements
   * become clearer. The change is likely to be an (additive) breaking API
   * change, in the form of a more specific, feedback-focused type on the
   * provider with information about success/failure.
   *
   * When a thumbs down button is clicked
   */
  THUMBS_DOWN: 'THUMBS_DOWN',
  /**
   * Please check with Ethan/PM upon removing onExperienceEvent
   * calls, to confirm it is no longer used in any ongoing experiments.
   * Specifically `REVIEW_STATE_ENTERED` && `EXPERIENCE_COMPLETE`
   */
  /**
   * When a user enters ANY review state (initial/interrogate)
   */
  REVIEW_STATE_ENTERED: 'REVIEW_STATE_ENTERED',
  /**
   * When the experience is complete (e.g. clicked an action in the preview
   * screen leading to insertion of ai content)
   */
  EXPERIENCE_COMPLETE: 'EXPERIENCE_COMPLETE'
  /**
   * Experimenting with prompt_with_user_input in the event we trigger a tour
   * from deeper inside(?)
   *
   * At current stage, we may only have a single tour onload, and this may
   * be unnecessary - but adding it in as flexible, and we can deprecate/leave
   * unused if we don't need it.
   *
   * 2023.0530 - leaving this out for now, as we don't have a use case for it,
   * and can add it with quick turnaround if it is needed.
   */
  // PROMPT_WITH_USER_INPUT: 'PROMPT_WITH_USER_INPUT',
  /**
   * Not surfacing a "STARTED_STATE" esque prompt, as we don't have a use case
   * right now (triggering a tour from STARTED_STATE is not the right spot, as
   * it could shortcut straight into loading from a summarise use case.)
   */
  // STARTED_STATE: 'STARTED_STATE',
  // EXPERIENCE_START: 'EXPERIENCE_START',
  // EXPERIENCE_END: 'EXPERIENCE_END',
};

// EDF-1840
// Not used at the moment, but could be used in the future to signify
// users interacting with generic AI.
// type ConvoAIProvider = {
// 	type: 'convo-ai';
// };

/**
 * Provide contextual information to control hashes of channelIDs for use with
 * assistance-service.
 */

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any

/**
 * The `sentiment` parameter is being extracted to
 * avoid double typing in analyticsFlowTypes, specifically
 * userFeedbackSentiment
 */

export function isConvoAIKnownMessageTemplate(type) {
  return ['ANALYSING_QUERY', 'CONTENT_SEARCH', 'PAGE_HYDRATION', 'NEXT_BEST_TASK', 'WRITING'].includes(type);
}